import { render, staticRenderFns } from "./accountList.vue?vue&type=template&id=50b031ef&scoped=true&lang=html&"
import script from "./accountList.vue?vue&type=script&lang=js&"
export * from "./accountList.vue?vue&type=script&lang=js&"
import style0 from "./accountList.vue?vue&type=style&index=0&id=50b031ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b031ef",
  null
  
)

export default component.exports